(function($){

	$(document).ready(function(){
		
		$(document).on('click','.video-module .video-poster', function(e){
			$video = this.parentElement.querySelector('.video');
			$video.play();
			$(this).siblings('.play-icon').hide();
			$(this).hide();
		});
		
	});
	
})(jQuery);